export default [
  {
    name: 'getSysFeedback',
    method: 'GET',
    path: '/vue/system/feedback-get'
  },
  {
    name: 'getSysFeedbackPage',
    method: 'POST',
    path: '/vue/system/feedback-page'
  },
  {
    name: 'saveSysFeedback',
    method: 'POST',
    path: '/vue/system/feedback-save'
  },
  {
    name: 'deleteSysFeedback',
    method: 'POST',
    path: '/vue/system/feedback-delete'
  }
];
